import TemplateView from "../TemplateView";
import LoadingMoire from "../LoadingMoire";

export default class ChartSection extends TemplateView {

    constructor($containerEl, {
        chartContainerId,
        needHiddenContainer = false
    }) {
        super($containerEl);
        this.params = {
            chartContainerId,
            needHiddenContainer
        }

        this.state = {
            collapsed: null,
            containerSize: {
                height: 0,
                width: 0
            },
            rendering: false
        }

        this.onStatePropertyChanged("collapsed", (collapsed) => this.onCollapsed(collapsed));

        this.onStatePropertyChanged("containerSize", (size) => {
            this.$chartContainer.css("width", size.width);
            this.$chartContainer.css("height", size.height);
        });

        this.onStatePropertyChanged("rendering", (rendering) => this._renderChartMoire.toggle(rendering));
    }

    templateHtml() {
        return "<div class='chartSection'>" +
               "    <div class='containerHeader'>" +
               "        <div class='header'/>" +
               "        <div class='collapseButton noprint'/>" +
               "    </div>" +
               "    <div class='chartContainerWrapper'>" +
               "        <div id='<%=params.chartContainerId%>' class='chartContainer'></div>" +
               "        <% if (params.needHiddenContainer) { %>" +
               "        <div id='<%=chartContainerId%>Hidden' class='hiddenChartContainer'></div>" +
               "        <% } %>" +
               "    </div>" +
               "</div>"
    }

    afterRender() {
        this.$header = this.find(".header");
        this.$collapseBtn = this.find(".collapseButton");
        this.$chartContainer = this.find(".chartContainer");
        this.$hiddenChartContainer = this.find(".hiddenChartContainer");
        this.$chartContainerWrapper = this.find(".chartContainerWrapper");

        this.$collapseBtn.click(() => this.setState({collapsed: !this.state.collapsed}));
        this._renderChartMoire = new LoadingMoire().init(this.$chartContainerWrapper)
    }

    onCollapsed(collapsed) {
        this.$el.toggleClass("collapsed", collapsed);
    }
}


// WEBPACK FOOTER //
// ./web/js/chart/ChartSection.js